module.exports = "query {\n    getPersonCategories(load10LatestPersons: false) {\n        id\n        name\n    }\n}\n"